import {Component, OnInit, ViewChild} from '@angular/core';
import { MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {Event} from '../models/event';
import {EventDialogComponent} from './dialogs/event-dialog/event-dialog.component';
import {EventService} from '../services/event.service';
import {MatPaginator} from '@angular/material/paginator';
import {Subscription} from 'rxjs';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {EventPreviewService} from '../services/event-preview.service';
import {EventPreviewDialogComponent} from './dialogs/event-preview-dialog/event-preview-dialog.component';
import {AuthService} from '../services/auth.service';
import {Router} from "@angular/router";
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {KnowledgeService} from '../services/knowledge.service';
import {AlertComponent} from '../shared/dialogs/alert/alert.component';

@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  styleUrls: [ './event.component.scss' ],
  entryComponents: [
    EventDialogComponent,
    ConfirmComponent
  ]
})

export class EventComponent implements OnInit {

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  public Editor = ClassicEditor;

  private sub: Subscription;
  public dataSource: MatTableDataSource<any>
  //public displayedColumns: string[] = [ 'icon', 'date', 'name', 'more', 'preview', 'edit', 'delete' ];
  public displayedColumns: string[] = [ 'icon', 'date', 'name', 'more', 'preview', 'edit', 'delete' ];

  constructor (
    private db: AngularFirestore,
    public _authService: AuthService,
    public _eventService: EventService,
    public _knowledgeService: KnowledgeService,
    public _eventPreviewService: EventPreviewService,
    public dialog: MatDialog,
    public _router: Router) {

    if (!this._authService.isAdmin) {
      this._router.navigate([ 'home' ]);
    }

  }

  ngOnInit () {
    this._eventService.isCongress = false;
    this.sub = this._eventService.select(this.paginator, this._eventService.isCongress)
  }

  ngOnDestroy () {
    if (this.sub)
      this.sub.unsubscribe();
  }

  applyFilter (filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openDialog (event) {

    let eventData: Event = new Event();

    if (event) {
      eventData = event;
    } else {
      eventData = new Event();
      eventData.master = true;
      eventData.belongsToProduct = true;
    }

    eventData.congress = false
    this.dialog.open(EventDialogComponent, {
      panelClass: 'custom-dialog-container',
      //width: '1000px',
      //height: '610px',
      width: window.innerWidth.toString() + "px",
      height: window.innerHeight.toString() + "px",

      hasBackdrop: true,
      disableClose: true,
      data: eventData
    });

  }

  delete (element) {

    let event_id = element.id

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.name + "<br><br>Excluir este Evento?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        this._eventService.canDeleteEvent(event_id)
          .then((empty) => {

            console.log("empty: " + empty[ 0 ])

            if (empty[ 0 ]) {

              this._eventService.delete(event_id)
                .then(() => {
                  console.log("delete event success")
                })
                .catch(() => {
                  console.log("error delete event")
                })

            } else { // empty false: não apaga 
              //     console.log("não pode apagar");

              let dialogRef = this.dialog.open(AlertComponent, {
                width: '350px',
                height: '270px',
                panelClass: 'custom-dialog-container',
                data: {title: "Alerta", message: "Este evento não pode ser excluído pois existe um produto associado a ele."}
              });

            }
          })
          .catch((error) => {
            console.log("canDelete event error: " + error.message)
          })

      }
    })
  }

  preview (element) {

    console.log("preview element.id: " + element.id)

    this._eventPreviewService.getFullEvent({id: element.id})
      .then((ret: any) => {

        // console.log("---------------------------------------")
        console.log("getFullEvent: " + JSON.stringify(ret.data))
        // console.log("---------------------------------------")

        this.dialog.open(EventPreviewDialogComponent, {
          width: '800px',
          height: '610px',
          hasBackdrop: true,
          panelClass: 'custom-dialog-container',
          data: ret.data
        });

      })
    /*
      .catch((error) => {
      console.log("error " + JSON.stringify(error))
    })
    */


  }

  manageSlots () {

    let entity: any = {}

    entity = {
      'categories':
        [
          {
            'id': 'XkNpL8lctQ82mVgSXruw',
            'name': 'Aspirante cv'
          }
        ],
      'event_id': 'Y4LyBL487pOqWVUu907X',
      'event_name': 'Hands On • 2020',
      'name': 'Lote Único',
      "slot_quantity": 3,
      "slot_used": 0,
      "slot_wait": 10,
      "slot_wait_used": 0,
      "topic_id": "q1t6ewQAtabVDcUUvHMn",
      "topic_name": "PLASTIA DA VALVA MITRAL COM ANÉIS OU COM SUTURAS E RESSECÇÃO DA AURICULETA ESQUERDA"
    }

    return this.db.collection('sbccv_event_slots').add(entity)
      .then((result) => {
        console.log("result: " + result)
      })
      .catch((error) => {
        console.log("error: " + error)
      })
  }

  showHelp (id) {
    this._router.navigate([ 'knowledge_viewer/' + id ]);
  }

  gotoLettersSpeakers (element) {
    this._router.navigate([ '/letters-speakers/false/' + element.id ]);
  }

  gotoLettersSubscriptions (element) {
    this._router.navigate([ '/letters-subscriptions/false/' + element.id ]);
  }

  gotoCertificatesSpeakers (element) {
    this._router.navigate([ '/certificates-speakers/false/' + element.id ]);
  }

  gotoCertificatesSubscriptions (element) {
    this._router.navigate([ '/certificates-subscriptions/false/' + element.id ]);
  }

  gotoCertificatesArchives () {
    this._router.navigate([ '/certificates-archives/false' ]);
  }

  gotoCertificates (element) {
    this._router.navigate([ '/certificates/false/' + element.id ]);
  }

  _gotoPublish () {
    //  const url = this._router.serializeUrl(this._router.createUrlTree([ 'event-publish/' + this.event.key ]));
    //  window.open(url, '_blank');
  }

  async gotoPublish (event: any) {
    console.log(event.key)
    const url = this._router.serializeUrl(this._router.createUrlTree([ 'event-publish/' + event.key + ":" + false ]));
    window.open(url, '_blank');
  }

  _gotoSchedule () {
    //const url = this.router.serializeUrl(this.router.createUrlTree([ 'programa/' + this.master.key ]));
    //window.open(url, '_blank');
  }

  async gotoSchedule (event) {
    console.log(event)
    const url = this._router.serializeUrl(this._router.createUrlTree([ 'programa/' + event.key ]));
    window.open(url, '_blank');

    /*
    const master: any = await this._contextService.getMasterEvent(event.id);
    if (master.key == "51Congresso") {
      const url = this._router.serializeUrl(this._router.createUrlTree([ 'programa/' + master.key ]));
      window.open(url, '_blank');
    } else if (master.key == "sbccv50") {
      const url = this._router.serializeUrl(this._router.createUrlTree([ '/50' ]));
      window.open(url, '_blank');
    } else if (master.key == "49Congresso") {
      const url = this._router.serializeUrl(this._router.createUrlTree([ '/49' ]));
      window.open(url, '_blank');
    }
      */
  }


  /*

    gotoLetters (event) {
    this.router.navigate([ 'letters-v2/' + event.id + '/' + event.name + '/' + this._eventService.isCongress]);
  }

  gotoInvites (event) {
    this.router.navigate([ 'invites-v2/' + event.id + '/' + event.name + '/' + this._eventService.isCongress ]);
  }

  gotoResponses (event) {
    this.router.navigate([ 'responses-v2/' + event.id + '/' + event.name + '/' + this._eventService.isCongress ]);
  }

  gotoEventResponses (event) {
    this.router.navigate([ 'event-responses/' + event.id + '/' + event.name ]);
  }
  */


}